// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ScrollFloat from "../component/ScrollFloat";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Exchange() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const splitTextToSpans = (text, className = "") =>
    [...text].map((char, index) => (
      <span className={`char ${className}`} key={`${char}-${index}`}>
        {char === " " ? "\u00A0" : char}
      </span>
    ));

  // light dark change image

  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  const coinImages = [
    "assets/images/coin/coin_01.png",
    "assets/images/coin/coin_02.png",
    "assets/images/coin/coin_03.png",
    "assets/images/coin/coin_04.png",
    "assets/images/coin/coin_05.png",
    "assets/images/coin/coin_06.png",
    "assets/images/coin/coin_07.png",
    "assets/images/coin/coin_08.png",
    "assets/images/coin/coin_09.png",
    "assets/images/coin/coin_10.png",
    "assets/images/coin/coin_11.png",
    "assets/images/coin/coin_12.png",
  ];

  const tabData = [
    {
      id: "derivatives",
      title: "Derivatives",
      disabled: false,
      services: [
        {
          title: "Exchange Consulting Services",
          lightImage: "assets/images/exchange/der1-light.svg",
          darkImage: "assets/images/exchange/der1-dark.svg",
          desc: "As a top-tier centralized cryptocurrency exchange development company, we offer consulting services to clients to facilitate a smooth transition into the world of crypto.",
        },
        {
          title: "Custom Exchange Development",
          lightImage: "assets/images/exchange/der2-light.svg",
          darkImage: "assets/images/exchange/der2-dark.svg",
          desc: "We have a team of proficient developers who have the potential to build customized centralized exchanges exactly according to the needs of businesses, thereby ensuring complete satisfaction.",
        },
        {
          title: "Crypto Exchange Software",
          lightImage: "assets/images/exchange/der3-light.svg",
          darkImage: "assets/images/exchange/der3-dark.svg",
          desc: "Our team develops high-end software for centralized cryptocurrency exchanges so that they are able to function smoothly and uninterruptedly.",
        },
        {
          title: "Exchange Security Solutions",
          lightImage: "assets/images/exchange/der4-light.svg",
          darkImage: "assets/images/exchange/der4-dark.svg",
          desc: "We offer top-notch security solutions for the centralized crypto exchanges developed by our team. Additionally, we offer security solutions for existing exchanges, ensuring safe transactions.",
        },
        {
          title: "Integration Services & Solutions",
          lightImage: "assets/images/exchange/der5-light.svg",
          darkImage: "assets/images/exchange/der5-dark.svg",
          desc: "Our integration services and solutions include the addition or modification of features and functionalities to already existing crypto exchanges to achieve desired results.",
        },
        {
          title: "Exchange Maintenance Services",
          lightImage: "assets/images/exchange/der6-light.svg",
          darkImage: "assets/images/exchange/der6-dark.svg",
          desc: "Our services include exchange maintenance solutions for both existing and new exchanges to make sure that they operate smoothly without any kind of technical glitch.",
        },
      ],
    },
    {
      id: "decentralized",
      title: "Decentralized",
      disabled: false,
      services: [
        {
          title: "DeFi Exchange Platform Development Consulting",
          lightImage: "assets/images/exchange/dec1-light.svg",
          darkImage: "assets/images/exchange/dec1-dark.svg",
          desc: "Design, develop and launch products using blockchain technology.",
        },
        {
          title: "Bespoke Decentralized Exchange App Development",
          lightImage: "assets/images/exchange/dec2-light.svg",
          darkImage: "assets/images/exchange/dec2-dark.svg",
          desc: "Leverage our global footprint and add technical velocity to your advantage.",
        },
        {
          title: "White Label Decentralized Exchange Software",
          lightImage: "assets/images/exchange/dec3-light.svg",
          darkImage: "assets/images/exchange/dec3-dark.svg",
          desc: "Development of new applications including management, maintenance and deployment.",
        },
        {
          title: "Decentralized Exchange Maintenance Services",
          lightImage: "assets/images/exchange/dec4-light.svg",
          darkImage: "assets/images/exchange/dec4-dark.svg",
          desc: "Build iOS, Android and Cross Platform applications with App store listing compliance.",
        },
        {
          title: "AI-Enhanced Decentralized Crypto Exchange Developmenty",
          lightImage: "assets/images/exchange/dec5-light.svg",
          darkImage: "assets/images/exchange/dec5-dark.svg",
          desc: "Enhance cybersecurity posture, increase compliance and build digital resilience.",
        },
        {
          title: "Market Making Services For DeFi Exchanges",
          lightImage: "assets/images/exchange/dec6-light.svg",
          darkImage: "assets/images/exchange/dec6-dark.svg",
          desc: "Create Design Systems, Interface Designs and User Experiences for your clients.",
        },
      ],
    },
    {
      id: "centralized",
      title: "Centralized",
      disabled: false,
      services: [
        {
          title: "Exchange Consulting Services",
          lightImage: "assets/images/exchange/cen1-light.svg",
          darkImage: "assets/images/exchange/cen1-dark.svg",
          desc: "As a top-tier centralized cryptocurrency exchange development company, we offer consulting services to clients to facilitate a smooth transition into the world of crypto.",
        },
        {
          title: "Custom Exchange Development",
          lightImage: "assets/images/exchange/cen2-light.svg",
          darkImage: "assets/images/exchange/cen2-dark.svg",
          desc: "We have a team of proficient developers who have the potential to build customized centralized exchanges exactly according to the needs of businesses, thereby ensuring complete satisfaction.",
        },
        {
          title: "Crypto Exchange Software",
          lightImage: "assets/images/exchange/cen3-light.svg",
          darkImage: "assets/images/exchange/cen3-dark.svg",
          desc: "Our team develops high-end software for centralized cryptocurrency exchanges so that they are able to function smoothly and uninterruptedly.",
        },
        {
          title: "Exchange Security Solutions",
          lightImage: "assets/images/exchange/cen4-light.svg",
          darkImage: "assets/images/exchange/cen4-dark.svg",
          desc: "NFT-Art-Marketplace-Consultation Exchange Security Solutions We offer top-notch security solutions for the centralized crypto exchanges developed by our team. Additionally, we offer security solutions for existing exchanges, ensuring safe transactions.",
        },
        {
          title: "Integration Services & Solutions",
          lightImage: "assets/images/exchange/cen5-light.svg",
          darkImage: "assets/images/exchange/cen5-dark.svg",
          desc: "Our integration services and solutions include the addition or modification of features and functionalities to already existing crypto exchanges to achieve desired results.",
        },
        {
          title: "Exchange Maintenance Services",
          lightImage: "assets/images/exchange/cen6-light.svg",
          darkImage: "assets/images/exchange/cen6-dark.svg",
          desc: "Our services include exchange maintenance solutions for both existing and new exchanges to make sure that they operate smoothly without any kind of technical glitch.",
        },
      ],
    },
    {
      id: "Margin_Trading",
      title: "Margin Trading",
      disabled: false,
      services: [
        {
          title: "High Leverage",
          lightImage: "assets/images/exchange/mar1-light.svg",
          darkImage: "assets/images/exchange/mar1-dark.svg",
          desc: "Allow your users to amplify their buying or selling power by using leverage up to multiple times.",
        },
        {
          title: "Multi-layer Security",
          lightImage: "assets/images/exchange/mar2-light.svg",
          darkImage: "assets/images/exchange/mar2-dark.svg",
          desc: "The market-leading security features like SSL implementation and two-factor authentication ensure legitimate user access.",
        },
        {
          title: "Advanced Order Types",
          lightImage: "assets/images/exchange/mar3-light.svg",
          darkImage: "assets/images/exchange/mar3-dark.svg",
          desc: "Our exchange is integrated with other trading order types such as market order, copy trading, and more.",
        },
        {
          title: "Powerful Trading Engine",
          lightImage: "assets/images/exchange/mar4-light.svg",
          darkImage: "assets/images/exchange/mar4-dark.svg",
          desc: "The powerful trading engine offers unprecedented speed and reliability, fortifying the performance of our exchange.",
        },
        {
          title: "Multi-currency Wallet",
          lightImage: "assets/images/exchange/mar5-light.svg",
          darkImage: "assets/images/exchange/mar5-dark.svg",
          desc: "The multi-currency wallet integrated into our exchange ensures secure and accelerated transactions for a spectrum of cryptocurrencies.",
        },
        {
          title: "Robust Admin Panel",
          lightImage: "assets/images/exchange/mar6-light.svg",
          darkImage: "assets/images/exchange/mar6-dark.svg",
          desc: "A robust Admin panel facilitates monitoring of user activities and transactions happening on the platform.",
        },
      ],
    },
    {
      id: "cryptocurrency",
      title: "Cryptocurrency",
      disabled: false,
      services: [
        {
          title: "Crypto Exchange Consulting",
          lightImage: "assets/images/exchange/crypto1-light.svg",
          darkImage: "assets/images/exchange/crypto1-dark.svg",
          desc: "New to crypto? Our top-notch consulting services tailored for first-timers turn first steps into power moves, smoothing the on-ramp to your crypto journey.",
        },
        {
          title: "Custom Exchange Development",
          lightImage: "assets/images/exchange/crypto2-light.svg",
          darkImage: "assets/images/exchange/crypto2-dark.svg",
          desc: "AI-enhanced cryptocurrency exchange software development engineered to the specifications and secured to the core.",
        },
        {
          title: "Crypto Payment Gateway Integration",
          lightImage: "assets/images/exchange/crypto3-light.svg",
          darkImage: "assets/images/exchange/crypto3-dark.svg",
          desc: "Groceries, jewelry, e-commerce, gas & even card giants—crypto payments are everywhere. Get ready with a gateway that accepts NFTs, tokenized RWAs, stablecoins and crypto.",
        },
        {
          title: "Cryptocurrency Legal Solutions",
          lightImage: "assets/images/exchange/crypto4-light.svg",
          darkImage: "assets/images/exchange/crypto4-dark.svg",
          desc: "Regulations change. Your exchange won’t flinch. Our cryptocurrency exchange platform development company, armed with an experienced team of attorneys, got the legal edge.",
        },
        {
          title: "White Label Exchange Development",
          lightImage: "assets/images/exchange/crypto5-light.svg",
          darkImage: "assets/images/exchange/crypto5-dark.svg",
          desc: "You’ve got the vision. We’ve got the script. Launch smarter with scalable white label crypto exchange software development solutions.",
        },
        {
          title: "Arbitrage Bot Development",
          lightImage: "assets/images/exchange/crypto6-light.svg",
          darkImage: "assets/images/exchange/crypto6-dark.svg",
          desc: "Designed by top-notch blockchain experts and powered by intelligence, our arbitrage bots do the heavy lifting so you stay ahead.",
        },
      ],
    },
  ];

  useEffect(() => {
    const updateImages = () => {
      const theme = document.documentElement.getAttribute("data-theme") || "light";
      document.querySelectorAll(".theme-image").forEach((img) => {
        const newSrc = img.getAttribute(`data-${theme}`);
        if (newSrc) img.src = newSrc;
      });
    };

    updateImages(); // run once

    // observe theme changes
    const observer = new MutationObserver(updateImages);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });

    return () => observer.disconnect();
  }, []);


  return (
    <>
      <Helmet>
        <title>Crypto Exchange Solutions | Development & Consulting | Blockcryp</title>
        <meta
          name="description"
          content="Get expert crypto exchange consulting, custom development, security solutions, and full-cycle maintenance with Blockcryp. Scalable and secure exchange software."
        />
        <meta
          name="keywords"
          content="crypto exchange development, exchange consulting services, custom exchange development, cryptocurrency exchange software, crypto exchange security solutions, exchange integration services, crypto platform maintenance, trading platform development, white label exchange software, crypto exchange support services"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="token_hero space80">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold mb-3"
              >
                Exchange
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Step into the world of digital finance with our cutting-edge crypto exchange development services. We build secure, scalable, and high-performance trading platforms tailored to your business goals. From spot and margin trading to advanced order matching engines, our solutions empower you to launch a robust exchange with seamless user experiences and institutional-grade security.
              </motion.p>

            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/exchange/exchange_hero2.webp"
                  alt="Image 1"
                  className="w-100"
                />
                {/* <img
                  src="assets/images/exchange/exchange_hero.webp"
                  alt="token hero"
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ----------  crypto custom exchanges start ------ */}
      <section className="space80 crypto_section">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 col-xl-6 order-lg-1 order-2">
              <motion.div
                className="mb-3"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <h2 className="heading_h3 fw-bold mb-4">
                  <span className="text-primary"> Cryptocurrency </span>
                  Exchange Development Company
                  <br className="d-none d-md-block"></br>
                </h2>
              </motion.div>
              <motion.p
                className="mb-4"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                Lead the tomorrow of trading with inventive AI-powered
                cryptocurrency exchange development services.
              </motion.p>

              <div className="row align-items-center">
                <div className="col-lg-12 col-md-6">
                  <motion.ul
                    className=""
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <li className="mb-3">
                      <i class="bi bi-check-circle-fill me-2"></i> 25+ Advanced
                      Trading Modules
                    </li>
                    <li className="mb-3">
                      <i class="bi bi-check-circle-fill me-2"></i> Next-Gen
                      Security, Powered by AI
                    </li>
                    <li className="mb-3">
                      <i class="bi bi-check-circle-fill me-2"></i>100+
                      Third-Party Integrations
                    </li>
                    <li className="mb-3">
                      <i class="bi bi-check-circle-fill me-2"></i> UX Built For
                      10x Retention
                    </li>
                    <li className="mb-3">
                      <i class="bi bi-check-circle-fill me-2"></i> AI Integrated
                      Trading Infrastructure
                    </li>
                  </motion.ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-xl-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/exchange/company2.webp"
                  alt="Image 1"
                  className="w-100"
                />
              </motion.div>
              {/* <motion.img
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/exchange/company.webp"
                alt=""
                className="w-75"
              /> */}
            </div>
          </div>
        </div>
      </section>
      {/* ----------  crypto custom exchanges end ------ */}

      {/* --------- -- type  Derivatives start -------- */}
      <section className="space80 overflow-hidden derivatives">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.09}
                textClassName="heading_h3 fw-bold mb-3 text-center"
              >
                Types of Crypto Derivatives Trading
              </ScrollFloat>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt text-center"
              >
                Take a look at the types of crypto derivatives trading
                <br className="d-none d-lg-block"></br> supported by our crypto
                derivatives exchanges.
              </motion.p>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card"
              >
                <img
                  src={
                    theme === "dark"
                      ? "assets/images/exchange/trad1-dark.svg"
                      : "assets/images/exchange/trad1-light.svg"
                  }
                  alt="Logo"
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 mb-3 fw-bold">
                  Futures Trading
                </h3>
                <div>
                  <p className="mb-0">
                    The buyer or seller decides upon a fixed price for the
                    crypto asset at a particular date in the future. The
                    contracts are standardized and have an expiration date.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card"
              >
                <img
                  src={
                    theme === "dark"
                      ? "assets/images/exchange/trad2-dark.svg"
                      : "assets/images/exchange/trad2-light.svg"
                  }
                  alt="Logo"
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 mb-3 fw-bold">
                  Forwards Trading
                </h3>
                <div>
                  <p className=" mb-0">
                    It is similar to futures trading but here the contract is
                    customizable and flexible as per the needs of both parties.
                    Both can alter the contract’s conditions including the
                    underlying asset.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card"
              >
                <img
                  src={
                    theme === "dark"
                      ? "assets/images/exchange/trad3-dark.svg"
                      : "assets/images/exchange/trad3-light.svg"
                  }
                  alt="Logo"
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 fw-bold">
                  Options Trading
                </h3>
                <div>
                  <p className=" mb-0">
                    The buyer reserves the right to or not to make the purchase
                    as per the agreed date. In addition to the date, the buyer
                    can ask for a purchase at a particular time.
                  </p>
                </div>
              </motion.div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 mb-3">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="about_card"
              >
                <img
                  src={
                    theme === "dark"
                      ? "assets/images/exchange/trad4-dark.svg"
                      : "assets/images/exchange/trad4-light.svg"
                  }
                  alt="Logo"
                  className="mb-4"
                />
                <h3 className="text-start heading_h5 fw-bold">
                  Perpetual Trading
                </h3>
                <div>
                  <p className="mb-0">
                    Both parties exchange one type of cash flow for another on a
                    particular date in the future. These swaps are mostly
                    governed by interest rates, currencies, and commodities.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* --------- --type Derivative section end -------- */}

      {/* ------- marketing exchnage start -------- */}
      <section className="space80 crypto_section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-xl-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/exchange/vation2.webp"
                  alt="Image 1"
                  className="w-100"
                />
              </motion.div>
              {/* <motion.img
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/exchange/vation.webp"
                alt=""
                className="w-100 pe-0 pe-lg-5 mb-4"
              /> */}
            </div>
            <div className="col-lg-6 col-xl-6">
              <motion.div
                className="mb-3"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <h2 className="heading_h3 fw-bold mb-4">
                  Propelling The Industry With Our Innovations
                  <br className="d-none d-md-block"></br>
                </h2>
              </motion.div>
              <motion.p
                className="mb-4"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                We are a leading crypto-native market making company, comprising
                a team of skilled traders, developers, and innovators who
                constantly push the boundaries to shape the future of Web3. Our
                team of highly skilled and seasoned algo trading professionals
                specializes in quantitative and high-frequency trading.
              </motion.p>
              <motion.p
                className="mb-4"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                Our core mission is to bridge the gap between demand and supply
                in cryptocurrency markets worldwide through transparent,
                efficient, and compliant solutions that have demonstrated
                success in building mature markets.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      {/* ------- marketing exchnage end -------- */}

      {/* ---------  Security start ----------- */}
      <section className="specialties space80">
        <div className="container">
          <div className="row align-items-center justify-content-between g-4">
            <div className="col-lg-6 col-xl-5">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/exchange/security2.webp"
                  alt="Image 1"
                  className="w-100 h-100"
                />
              </motion.div>
              {/* <motion.img
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                src="assets/images/exchange/security1.webp"
                alt=""
                className="border_xl w-100 h-75 "
              /> */}
            </div>
            <div className="col-lg-6">
              <div className="specialties_card border_lg">
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h4 fw-bold mb-3 text-capitalize"
                >
                  <span className="text-primary">Security Practices </span>
                  of our Margin Trading Exchange
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="mb-4"
                >
                  We harness advanced features to reinforce the security of our
                  crypto and Bitcoin margin trading exchange.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                >
                  <ul>
                    <li className="d-flex gap-3 align-items-start mb-2">
                      <div>
                        <i class="bi bi-check2-circle text_24"></i>
                      </div>
                      <div>
                        <h6 className="fw-bold mt-1">Wallet Security</h6>
                        <p className="text-secondary mb-2">
                          with multi-signature withdrawal
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 align-items-start mb-2">
                      <div>
                        <i class="bi bi-check2-circle text_24"></i>
                      </div>
                      <div>
                        <h6 className="fw-bold mt-1">System Security</h6>
                        <p className="text-secondary mb-2">
                          with multi-level authentication
                        </p>
                      </div>
                    </li>
                    <li className="d-flex gap-3 align-items-start mb-2">
                      <div>
                        <i class="bi bi-check2-circle text_24"></i>
                      </div>
                      <div>
                        <h6 className="fw-bold mt-1">Communication Security</h6>
                        <p className="text-secondary mb-2">
                          with high-level encryption
                        </p>
                      </div>
                    </li>
                  </ul>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------  Security end ----------- */}

      {/* ------------ service section start -- */}
      <section className="space80 crypto_section">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center"
              >
                Our <span className="text-primary ps-2">Services</span>
              </motion.h2>
            </div>
          </div>
          <div className="row">
            <motion.ul
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
              viewport={{ once: false, amount: 0.5 }}
              className="nav nav-tabs service_tab"
              id="myTab"
              role="tablist"
            >
              {tabData.map((tab, index) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <button
                    className={`tab-button nav-link ${index === 0 ? "active" : ""
                      }`}
                    id={`${tab.id}-tab`}
                    data-bs-toggle="tab"
                    data-bs-target={`#${tab.id}-tab-pane`}
                    type="button"
                    role="tab"
                    aria-controls={`${tab.id}-tab-pane`}
                    aria-selected={index === 0}
                    disabled={tab.disabled}
                  >
                    {tab.title}
                  </button>
                </li>
              ))}
            </motion.ul>

            <div className="tab-content mt-5" id="myTabContent">
              {tabData.map((tab, index) => (
                <div
                  key={tab.id}
                  className={`tab-pane fade ${index === 0 ? "show active" : ""
                    }`}
                  id={`${tab.id}-tab-pane`}
                  role="tabpanel"
                  aria-labelledby={`${tab.id}-tab`}
                  tabIndex={0}
                >
                  <ul className="row">
                    {tab.services.map((service, idx) => (
                      <li className="col-xl-4 col-lg-6 col-md-6 mb-4" key={idx}>
                        <motion.div
                          initial={{ opacity: 0, y: 50 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 1, delay: 0.5 }}
                          viewport={{ once: false, amount: 0.5 }}
                          className="solution-box p-4 rounded-4 shadow-sm h-100"
                        >
                          <img
                            src={document.documentElement.getAttribute("data-theme") === "dark" ? service.darkImage : service.lightImage}
                            data-light={service.lightImage}
                            data-dark={service.darkImage}
                            className="mb-3 theme-image"
                            alt={service.title}
                          />

                          <h5 className="text_20 fw-semibold">{service.title}</h5>
                          <p className="mb-0 text_14">{service.desc}</p>
                        </motion.div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* ------------ service section end -- */}
      {/* -----------  support platform start ----------- */}
      <section className="space60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12 ">
              <div className="support_slider space60 border_xl p-4 p-md-5">
                <div className="text-center">
                  <motion.h2
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="heading_h3 fw-bold text-light mb-4"
                  >
                    Blockchain Development Platforms <br></br>{" "}
                    <span className="text-primary"> We Support </span>
                  </motion.h2>
                  <motion.p
                    initial={{ opacity: 0, y: -50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="text-white"
                  >
                    {" "}
                    As a leading custom blockchain development company, we
                    leverage different blockchain{" "}
                    <br className="d-none d-lg-block"></br>networks to provide
                    you with the best solutions aligned with your needs.
                  </motion.p>
                </div>
                <div className="space60">
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    navigation
                    loop={true}
                    autoplay={{ delay: 800, disableOnInteraction: false }}
                    speed={1000}
                    spaceBetween={20}
                    slidesPerView={6}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                      },
                      480: {
                        slidesPerView: 3,
                      },
                      768: {
                        slidesPerView: 4,
                      },
                      1024: {
                        slidesPerView: 5,
                      },
                      1200: {
                        slidesPerView: 6,
                      },
                      1400: {
                        slidesPerView: 6,
                      },
                    }}
                  >
                    {coinImages.map((src, index) => (
                      <SwiperSlide key={index} className="text-center">
                        <img src={src} alt={`Coin Slide ${index + 1}`} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* -----------  support platform end ----------- */}

      {/* ---------- faq section start ---------- */}
      <section className="space40">
        <div className="container">
          <h2 className="heading_h3 fw-bold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="accordion">
                <div
                  className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(0)}
                  >
                    <span className="text_20 pe-4">
                      1.  What is white label crypto exchange?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      A white label crypto exchange software is a market-ready solution that lets highly regulated financial bodies, forex trading companies and existing crypto-based businesses configure and roll out a fully functional trading platform. </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(1)}
                  >
                    <span className="text_20 pe-4">
                      2. What is Decentralized Exchange Software?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      A decentralized crypto exchange software is a platform that facilitates digital asset trades through self-executing programs (known as smart contracts). No central authority or intermediary is involved, and trades are carried out independently over a digitized distributed ledger. The non-custodial platforms enable peer-to-peer transactions while ensuring customers have complete control over their private keys.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(2)}
                  >
                    <span className="text_20 pe-4">
                      3.  Do you offer customized crypto derivatives exchange development services?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Yes, of course! We have a team of adequately trained and vastly experienced experts to cater to the exact needs of different businesses in the best possible manner to ensure a hundred percent satisfaction among all. Feel free to discuss your requirements with our team to get customized solutions.

                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(3)}
                  >
                    <span className="text_20 pe-4">
                      4.  What is Decentralized Exchange Software?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      A decentralized crypto exchange software is a platform that facilitates digital asset trades through self-executing programs (known as smart contracts). No central authority or intermediary is involved, and trades are carried out independently over a digitized distributed ledger. The non-custodial platforms enable peer-to-peer transactions while ensuring customers have complete control over their private keys.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 "
                    onClick={() => toggleItem(4)}
                  >
                    <span className="text_20 pe-4">
                      5. How to start a centralized exchange?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      You can build a centralized crypto exchange from scratch, you can opt for a readymade clone script, or you can choose a whitelabel centralized exchange solution. You can get in touch with our team of developers to build an exchange as per your requirements.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 5 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 "
                    onClick={() => toggleItem(5)}
                  >
                    <span className="text_20 pe-4">
                      6.  What is margin trading?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Margin trading involves borrowing funds to amplify potential returns when buying and selling cryptocurrency. When leverage trading, traders can access increased buying/selling power and may open positions that are much larger than the actual account balance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
